import React from "react";
import { default as MuiToogleButton } from "@mui/material/ToggleButton";

function ToogleButton(props) {
  return <MuiToogleButton {...props} />;
}

export default ToogleButton;
